import { lazy, Suspense, useState } from "react";
import { LuUser } from "react-icons/lu";
import { useI18n } from "../../i18n";
import useLocalStorage from "use-local-storage";

const AuthDialogs = lazy(() => import("./AuthDialogs"));

export default function LoginRegisterButton() {
  const { t } = useI18n();
  const [userProfile, setUserProfile] = useLocalStorage("userProfile");
  const [modalLogin, setModalLogin] = useState(false);
  const [modalProfile, setModalProfile] = useState(false);
  const [modalChangePassword, setModalChangePassword] = useState(false);

  const toggleLogin = () => setModalLogin(!modalLogin);
  const toggleProfile = () => setModalProfile(!modalProfile);
  const toggleChangePassword = () => setModalChangePassword(!modalChangePassword);

  const anyOpen = modalLogin || modalProfile || modalChangePassword;

  const initials = userProfile
    ? `${(userProfile.firstName || '')[0] || ''}${(userProfile.lastName || '')[0] || ''}`.toUpperCase()
    : '';

  return (
    <>
      {userProfile ? (
        <button type="button" className="f-topbar-chip" onClick={toggleProfile}>
          <span className="f-avatar" aria-hidden>{initials}</span>
          <span className="f-hide-sm">{userProfile.firstName}</span>
        </button>
      ) : (
        <button type="button" className="f-topbar-chip solid" onClick={toggleLogin}>
          <LuUser size={16} /> {t("nav.signIn")}
        </button>
      )}

      {anyOpen && (
        <Suspense fallback={null}>
          <AuthDialogs
            modalLogin={modalLogin}
            toggleLogin={toggleLogin}
            modalProfile={modalProfile}
            toggleProfile={toggleProfile}
            modalChangePassword={modalChangePassword}
            toggleChangePassword={toggleChangePassword}
          />
        </Suspense>
      )}
    </>
  );
}
